<!-- src/views/home/index.vue -->
<template>
    <div>
        Home
    </div>
</template>

<script setup></script>

<style scoped></style>